import { useGetSingleFireAppcuesTracker } from '@upright/ui/integrations/appcues';
import { AppcuesEventId, AppcuesEventPropertiesById } from '@upright/ui/integrations/appcues/types';
import { useMaybeCsrdCompanyContext } from './context';

// Needs to be located under CsrdCompanyContext in order to track events.
// In other words, doesn't track events e.g. in the onboarding wizard for PLG.
export function useSingleFirePlgAppcuesTracker<T extends AppcuesEventId>(
  eventId: T,
  properties?: AppcuesEventPropertiesById[T],
) {
  const trackSingleFireAppcuesEvent = useGetSingleFireAppcuesTracker();

  const shouldTrackPlgAppcuesEvents = useMaybeCsrdCompanyContext()?.shouldTrackPlgAppcuesEvents;
  if (!shouldTrackPlgAppcuesEvents) return;
  trackSingleFireAppcuesEvent(eventId, properties);
}
